import React, { useState } from 'react';
import PropTypes from 'prop-types';
import routes from 'routes';
import arrayMutators from 'final-form-arrays';
import { changeValueMutator } from 'helpers/FormHelper';
import roundReportStorageItemAdminStatuses from 'enums/roundReportStorageItemAdminStatuses';

import { Link } from 'react-router-dom';
import Form from 'form/Form';
import Button from '@material-ui/core/Button';
import AdminFormWrapper from '../../presentational/AdminFormWrapper';
import AdminFormFields from '../../presentational/AdminFormFields';
import AdminFormButtons from '../../presentational/AdminFormButtons';
import ReadOnlyField from '../../presentational/ReadOnlyField';
import NoteList from '../../presentational/NoteList';
import ShortDateTime from 'common/ShortDateTime';
import BookingList from './BookingList';
import PreviousItemList from './PreviousItemList';
import { Radios } from 'mui-rff';
import Lightbox from 'react-image-lightbox';

import 'react-image-lightbox/style.css';

const EditRoundReportStorageItemForm = ({ roundReportStorageItem, isSubmitting = false, onSubmit, onCancel, onSendEmailButtonClick}) => {
    const [lightboxOpen, setLightboxOpen] = useState(false);

    const initialValues = {
        adminStatus: roundReportStorageItem.adminStatus
    };

    const handleFormSubmit = formValues => {
        onSubmit(formValues);
    };

    const getImageMarkup = () => {
        const src = roundReportStorageItem.imageUrl;
        if(!src) {
            return undefined;
        }

        return (
            <>
                <img
                    src={src}
                    onClick={() => setLightboxOpen(true)}
                />
                {
                    lightboxOpen &&
                    (
                        <Lightbox
                            mainSrc={src}
                            onCloseRequest={() => setLightboxOpen(false)}
                        />
                    )
                }
            </>
        );
    };

    const adminStatusItems = Object.values(roundReportStorageItemAdminStatuses)
        .map(o => ({
            label: o.key,
            value: o.key
        }));

    const allRoundReportStorageItems = [roundReportStorageItem].concat(roundReportStorageItem.previousRoundReportStorageItems);

    return (
        <AdminFormWrapper isSubmitting={isSubmitting}>
            <Form
                initialValues={initialValues}
                mutators={{
                    ...arrayMutators,
                    changeValue: changeValueMutator
                }}
                onSubmit={handleFormSubmit}
            >
                {({ handleSubmit }) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <AdminFormFields>
                                <ReadOnlyField label="Storage site">
                                    <Link to={routes.storageSiteDetails.replace(':storageSiteId', roundReportStorageItem.storageSiteId)} target="_blank">{roundReportStorageItem.storageSiteTitle}</Link>
                                </ReadOnlyField>

                                <ReadOnlyField label="Storage">
                                    {roundReportStorageItem.storageTitle}
                                </ReadOnlyField>

                                <ReadOnlyField label="Submitted time">
                                    <ShortDateTime value={roundReportStorageItem.modifiedTime}/>
                                </ReadOnlyField>

                                <ReadOnlyField label="Status">
                                    <Radios
                                        name="adminStatus"
                                        data={adminStatusItems}
                                    />
                                </ReadOnlyField>

                                {
                                    getImageMarkup() &&
                                    (
                                        <ReadOnlyField label="Image">
                                            {getImageMarkup()}
                                        </ReadOnlyField>
                                    )
                                }

                                <ReadOnlyField label="Recent bookings for this storage">
                                    {
                                        roundReportStorageItem.bookings.length === 0 && 'None'
                                    }
                                    {
                                        roundReportStorageItem.bookings.length > 0 &&
                                        (
                                            <BookingList
                                                bookings={roundReportStorageItem.bookings}
                                                onSendEmailButtonClick={onSendEmailButtonClick}
                                            />
                                        )
                                    }
                                </ReadOnlyField>

                                <ReadOnlyField label="All reports for this storage">
                                    <PreviousItemList items={allRoundReportStorageItems}/>
                                </ReadOnlyField>

                                <NoteList notes={roundReportStorageItem.notes}/>
                            </AdminFormFields>

                            <AdminFormButtons>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                >
                                    Save
                                </Button>
                                <Button
                                    type="button"
                                    variant="outlined"
                                    color="primary"
                                    onClick={onCancel}
                                >
                                    Cancel
                                </Button>
                            </AdminFormButtons>
                        </form>
                    );
            }}
            </Form>
        </AdminFormWrapper>
    );
};

EditRoundReportStorageItemForm.propTypes = {
    roundReportStorageItem: PropTypes.object.isRequired,
    isSubmitting: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSendEmailButtonClick: PropTypes.func.isRequired,
};

export default EditRoundReportStorageItemForm;
